module.exports = __webpack_public_path__ + "img/video-1.7d3aeba7.jpg";